/**
 * Vendor Organizations API service — migrated to typed `@tiaki/http-client`
 * per ADR 113 §Decision.
 */
import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

export interface VendorOrganization {
  id: number;
  name: string;
  public_id: string;
  status: string;
}

/**
 * Get onboarding organizations available to the authenticated vendor user
 */
export async function getVendorOnboardingOrganizations(): Promise<
  VendorOrganization[]
> {
  const result = await client.GET('/api/v2/vendor/onboarding-organizations/', {});
  return unwrap(result) as unknown as VendorOrganization[];
}
